import api from "./fetch"

import { ConfigType } from "@/types"

async function fetchConfig (locale: string): Promise<ConfigType> {

  const query = { locale }

  const { data } = await api(`api/config`, { cache: 'no-store' }, query )

  return data
}

export default fetchConfig